import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as globalActions from 'Backend/Redux/actions/globalActions'
import { Dropdown, Menu } from 'antd'
import jaLocale from 'moment/locale/ja'
import enLocale from 'moment/locale/en-au'
import moment from 'moment'
import Images from 'Assets/Images'
import { useTranslation } from 'react-i18next'
import './style.scss'

const configRenderLanguage = [
  {
    title: 'EN',
    lang: 'en',
    src: Images.flags['en']
  },
  {
    title: '日本語',
    lang: 'jp',
    src: Images.flags['jp']
  }
  // {
  //   title: '中文',
  //   lang: 'cn',
  //   src: images.flags['cn']
  // }
]

const LanguageSwitcher = (props) => {
  const { i18n } = useTranslation();
  const onSetLocale = (lang) => () => {
    const { setLocale } = props
    i18n.changeLanguage(lang)
    setLocale && setLocale(lang)
    switch (lang) {
    case 'en':
      moment.updateLocale('en', enLocale, {
        monthsShort: [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ]
      })
      break
    case 'ja':
      moment.updateLocale('ja', jaLocale, {
        monthsShort: [
          '1月', '2月', '3月', '4月', '5月', '6月',
          '7月', '8月', '9月', '10月', '11月', '12月'
        ]
      })
      moment.updateLocale('ja', {
        weekdays: ['(日)', '(月)', '(火)', '(水)', '(木)', '(金)', '(土)']
      })
      break
    case 'cn':
      moment.updateLocale('ja', jaLocale, {
        monthsShort: [
          '1月', '2月', '3月', '4月', '5月', '6月',
          '7月', '8月', '9月', '10月', '11月', '12月'
        ]
      })
      moment.updateLocale('ja', {
        weekdays: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      })
      break
    }
  }
  const menuLanguage = () => {
    let selectOptionList = configRenderLanguage.filter(
      (obj) => obj.lang !== props.locale
    )
    return (
      <React.Fragment>
        <Menu
          className='menu-flag'
          theme='light'
          mode='vertical'
          style={{ lineHeight: '50px', background: '#fff' }}
        >
          {selectOptionList.map((item, i) => (
            <Menu.Item key={i} className='menu-flag-item'>
              <span onClick={onSetLocale(item.lang)}>
                <img className='flags' alt={item.title} src={item.src} />
                {`${item.title}`}
              </span>
            </Menu.Item>
          ))}
        </Menu>
      </React.Fragment>
    )
  }
  let currentSelectedObj = configRenderLanguage.find(
    (obj) => obj.lang === (props.locale || 'en')
  )
  return (
    <Dropdown overlay={menuLanguage}>
      <a className='ctn-select-lang ant-dropdown-link' onClick={e => e.preventDefault()}>
        <img
          className='selected-flag'
          alt={currentSelectedObj.title}
          src={currentSelectedObj.src}
        />
        <span className='text text-bold text-color-main PR5'>{currentSelectedObj.title}</span>
        <img src={Images.icArrowUp} />
      </a>
    </Dropdown>
  )
}
const mapStateToProps = (state) => ({
  locale: state.locale
})
const mapDispatchToProps = (dispatch) => {
  return {
    setLocale: bindActionCreators(globalActions.setLocale, dispatch)
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(LanguageSwitcher)
